// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"9b066c8c","320":"3ec2ebf6","604":"7ebf573e","616":"1c95446c","849":"4e2a38ab","875":"213b2a4d","950":"2134e488"}[chunkId] + ".chunk.js";
};